import React from 'react';
import { useTranslation } from 'react-i18next';

export type Props = {
    source?: 'EL' | 'MS' | 'LP' | 'M1';
};

export const EventSourceIcon = ({ source }: Props) => {
    const { t } = useTranslation();
    switch (source) {
        case 'EL':
            return <i className="ui small blue phone icon" title={ t('VIDEO.ELEVATOR') }/>;
        
        case 'LP':
            return <i className="ui small grey building outline icon" title={ t('VIDEO.LOBBY_PANEL') }/>;
                   
        case 'MS':
            return <i className="ui small grey desktop icon" title={ t('VIDEO.MONITORING_STATION') }/>;
    }
    return null;
};
